import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/components/AuthShell";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      navigate(location.state?.from || (u.role === "admin" ? "/admin" : "/book"), { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell eyebrow="Members" title="Log in" testId="login-page">
      <form onSubmit={submit} className="space-y-6" data-testid="login-form">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" className="h-12" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" className="h-12" />
        </div>
        {error && <p className="text-sm text-[#FF3333]" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-riot w-full" data-testid="login-submit-btn">
          {loading ? "Logging in…" : "Log in"}
        </button>
        <p className="text-sm text-zinc-400">
          New here?{" "}
          <Link to="/register" state={location.state} className="text-white underline-offset-4 hover:text-[#FF3333] hover:underline" data-testid="login-register-link">
            Create an account
          </Link>
        </p>
      </form>
    </AuthShell>
  );
}
